/**
 * @internal
 */ export const ganttClassNames = {
    root: '',
    xAxis: '',
    yAxis: '',
    legendContainer: '',
    hover: '',
    descriptionMessage: '',
    tooltip: '',
    axisTitle: '',
    chartTitle: '',
    opacityChangeOnHover: '',
    shapeStyles: '',
    chartWrapper: '',
    svgTooltip: '',
    chart: '',
    axisAnnotation: '',
    plotContainer: '',
    annotationLayer: ''
};
/**
 * Apply styling to the GanttChart component
 */ export const useGanttChartStyles = (props)=>{
    return {};
};
